import { useEffect, useRef } from 'react';
import { View, StyleSheet, Platform, Dimensions } from 'react-native';
import { useTheme } from '../styles/theme';

export default function ReadingPositionIndicator() {
  const barRef = useRef<any>(null);
  const { width } = Dimensions.get('window');
  const isMobile = width <= 768;
  const { colors } = useTheme();

  useEffect(() => {
    if (!isMobile || Platform.OS !== 'web') return;

    const scrollPane = document.getElementById('scroll-center-pane-helper');
    if (!scrollPane) return;

    const handleScroll = () => {
      const contentPane = document.getElementById('scroll-center-pane');
      const contentHeight = contentPane ? contentPane.offsetHeight : scrollPane.scrollHeight;
      const totalDocHeight = contentHeight - window.innerHeight + 204;
      const pct = totalDocHeight > 0 ? Math.min((scrollPane.scrollTop * 100) / totalDocHeight, 100) : 0;
      if (barRef.current) {
        barRef.current.style.width = pct + '%';
      }
    };

    handleScroll();
    scrollPane.addEventListener('scroll', handleScroll, { passive: true });
    return () => scrollPane.removeEventListener('scroll', handleScroll);
  }, [isMobile]);

  if (!isMobile) return null;

  return (
    <View
      ref={barRef}
      nativeID="reading-position-indicator"
      style={[styles.bar, { backgroundColor: colors.readingIndicator }]}
    />
  );
}

const styles = StyleSheet.create({
  bar: {
    position: 'absolute' as any,
    top: 0,
    left: 0,
    height: 3,
    backgroundColor: undefined,
    zIndex: 2000,
    elevation: 2000,
  },
});
